import { useTheme } from '@/src/context/ThemeContext';
import { useTranslation } from '@/src/i18n';
import { blogPosts } from '@/src/content/blog';
import { BlogListScreen } from '@/src/presentation/screens/BlogListScreen';
import Head from 'expo-router/head';
import { useRouter } from 'expo-router';

export default function BlogListContainer() {
  const { colors } = useTheme();
  const { t, language } = useTranslation();
  const router = useRouter();

  const siteUrl = 'https://tournaly.app';
  const blogUrl = `${siteUrl}/blog`;
  const seoTitle = `${t('blog.title')} — Tournaly`;
  const seoDescription = t('blog.subtitle');
  const ogImage = `${siteUrl}/og-image.png`;

  const jsonLd = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: seoTitle,
    description: seoDescription,
    url: blogUrl,
    publisher: {
      '@type': 'Organization',
      name: 'Tournaly',
      url: siteUrl,
      logo: { '@type': 'ImageObject', url: ogImage },
    },
  });

  return (
    <>
      <Head>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <link rel="canonical" href={blogUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Tournaly" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={blogUrl} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Tournaly Blog" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />
        <script type="application/ld+json">{jsonLd}</script>
      </Head>
      <BlogListScreen
        posts={blogPosts}
        colors={colors}
        onPostPress={(slug) => router.push(`/blog/${slug}` as any)}
        onBack={() => router.push('/' as any)}
      />
    </>
  );
}
